import { createPromiseAction } from '@adobe/redux-saga-promise';

// Actions for listing eventVendors
export const listEventVendors = createPromiseAction('eventVendors/list');

// Actions for searching eventVendors
export const searchEventVendors = createPromiseAction('eventVendors/search');

// Actions for filtering eventVendors
export const filterEventVendors = createPromiseAction('eventVendors/filter');

// Actions for exporting eventVendors
export const exportEventVendors = createPromiseAction('eventVendors/export');

// Actions for viewing eventVendor details
export const getEventVendorInfo = createPromiseAction('eventVendors/info');

// Actions for updating eventVendor info
export const updateEventVendorInfo = createPromiseAction('eventVendors/updateInfo');

// Actions for adding a eventVendor
export const addEventVendor = createPromiseAction('eventVendors/add');
